<template>
    <div>
        <div v-if="isLoggedIn && currentAccessLevel != 'unknown'">
            <div v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser' && years" style="background-color: #eeeeee;">
                 <div class="comments-title-section">
                    <div class="comments-title">
                        <div class="back-link " @click="goBackClick()"> {{'< BACK'}} </div>
                    </div>
                    <div v-if="false" class="comments-top-actions">
                        <button style="margin-right: 50px;" v-if="!addNewFlow" @click="deleteComment()" :disabled="waitingForData" class="btn btn-light-arp">Delete Comment</button>
                    </div>
                </div>
                <div class="addEditCommentContainer">
                    <div class="ediAddCommentSection">
                        <div class="main-padding">
                            <div class="form-title">{{addNewFlow ? 'Add Comment' : 'Edit Comment'}}</div>
                            <form>
                                <div class="row">
                                    <div class="col-4">
                                        <div>
                                            <div class="filter-label">Year</div>
                                             <div style="width:195px;">
                                              <datepicker v-if="addNewFlow" :disabled="!addNewFlow?true:false" :calendar-class="'vdp-datepicker'" :value="modalSelectedYear" 
                                                v-model="modalSelectedYear" placeholder="Select Year" @selected="setYear()" 
                                                @opened="displayRequiredYears()" 
                                                name="years"  :minimum-view="'year'" :format="'YYYY'" :maximum-view="'year'" 
                                                :initial-view="'year'" :disabled-dates="disabledDates">
                                              </datepicker>
                                              <input v-else :value="modalSelectedYear" disabled readonly type="text" />
                                        </div>
                                        </div>
                                        <div v-if="this.modalSelectedMainCaterogy != 'Verticals'">
                                            <div class="filter-label">Program Name</div>
                                            <select class="form-control" :disabled="!addNewFlow?true:false" v-model="modalSelectedProgram">
                                                <option v-if="!addNewFlow">{{modalSelectedProgram}}</option>
                                                <option value="">Select Program</option>
                                                <option v-for="program in modalPrograms" :value="program" :key="program">{{program}}</option>
                                            </select>
                                        </div>
                                        <div v-if="this.modalSelectedMainCaterogy === 'Verticals'">
                                            <div class="filter-label">Vertical Name</div>
                                            <select class="form-control" :disabled="!addNewFlow?true:false" v-model="modalSelectedProgram">
                                                <option value="">Select Program</option>
                                                <option v-for="program in modalPrograms" :value="program" :key="program">{{program}}</option>
                                            </select>
                                        </div>
                                        <div v-if="selectedSubCategory || true" style="min-height: 221px;">
                                            <div class="period-filter">
                                                <div class="filter-label">Period</div>
                                                    <div class="period-radio-group">
                                                    <label for="month" class="radio" >
                                                        <input type="radio" name="period"  class="hidden" id="month" :disabled="!addNewFlow?true:false" :checked="periodSelector === 'Month'"  @click="handlePeriodRadioSelection" key="Month" value="Month"/>
                                                        <span class="label"></span>Month
                                                    </label>
                                                    <label for="quarter" class="radio" >
                                                        <input type="radio" name="period"  class="hidden" id="quarter" :disabled="!addNewFlow?true:false" :checked="periodSelector === 'Quarter'" @click="handlePeriodRadioSelection" key="qurter" value="Quarter"/>
                                                        <span class="label"></span>Quarter
                                                    </label>
                                                    <label for="annual" class="radio" >
                                                        <input type="radio" name="period"  class="hidden" id="annual" :disabled="!addNewFlow?true:false" :checked="periodSelector === 'Annual'"  @click="handlePeriodRadioSelection" key="Annual" value="Annual"/>
                                                        <span class="label"></span>Annual
                                                    </label>
                                                       <!-- <div><input class="period-input" :disabled="!addNewFlow?true:false" type="radio" name="period" :checked="periodSelector === 'All'" @click="handlePeriodRadioSelection"  key="All" value="All"/> All</div>-->
                                                    </div>
                                                    <div v-bind:class="[(periodSelector === 'Month' || periodSelector === 'Quarter') ? '' : '']" :v-if="periodSelector === 'Month' || periodSelector === 'Quarter'">
                                                        <div :v-if="periodSelector === 'Month' || periodSelector === 'Quarter'" v-bind:class="[(periodSelector === 'Month' || periodSelector === 'Quarter') ? 'filter-label' : 'no-display']">
                                                            {{periodSelector}}
                                                        </div>
                                                        <div v-if="periodSelector === 'Month'">
                                                            <select :disabled="!addNewFlow?true:false" class="form-control" v-model="modalSelectedPeriod">
                                                                <option value="">Select Month </option>
                                                                <option v-for="period in mPeriods" :key="period" :value="period">{{period}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-if="periodSelector === 'Quarter'">
                                                            <select :disabled="!addNewFlow?true:false" class="form-control" v-model="modalSelectedPeriod">
                                                                <option value="">Select Quarter </option>
                                                                <option v-for="period in qPeriods" :key="period" :value="period">{{period}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-8">
                                        <div class="form-group">
                                            <div class="filter-label">Comments</div>
                                            <textarea class="form-control" style="height: 300px;" @blur="hanldeTextAreaBlur" @focus="hanldeTextAreaFocus" id="exampleFormControlTextarea1" rows="8" v-model="modalTextArea"></textarea>
                                        </div>
                                        <div class="commentLatestEdit" v-if="editCommentCopy && editCommentCopy.latest_editor_email && editCommentCopy.latest_editor_fName && editCommentCopy.latest_editor_lName">
                                            <img class="conf-img time-white" src="../assets/img/time-white.svg" alt="Time-white" />
                                            <div class="lable-lite">Last Updated By : 
                                                <span class="editorName">{{editCommentCopy.latest_editor_fName}} {{editCommentCopy.latest_editor_lName}}</span>
                                                <span class="editorEmail">({{editCommentCopy.latest_editor_email}})</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="addEditButtonGroup">
                                <button @click="onCalcelClick()" :disabled="waitingForData" class="btn btn-light-arp">Cancel</button>
                                <button @click="editComment()" class="btn btn-warning-arp">ADD</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div v-else>
            <div class="jumbotron jumbotron-fluid">
                <div class="container">
                    <!-- <h1 class="display-4">Program Analysis & Reports</h1> -->
                    <br>
                    <div v-if="isLoggedIn">
                        
                        <p class="lead">You don't have sufficient permissions to access this information. Please Contact the administrator</p>
                    </div>
                    <div v-else>
                        <p class="lead"> Please Login to continue.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters} from "vuex"
import Datepicker from '@hokify/vuejs-datepicker';

export default {
    name: "Commentary",
    components:{
         Datepicker
     },
    methods: {
        ...mapActions(['login','getCommentsData','updateComments','updateOverlayParams','initDeleteComment','updateCommentaryParams','postEditComment','getMenuOptions','resetOverlay']),
        editComment(){
            if (this.addNewFlow) {
                this.addComment();
                return;
            }
            this.resetOverlay();
            var validation = this.validateEditComments()
            if(validation['status'] == true){
                var blob = {
                    "programName": this.modalSelectedProgram,
                    "year": this.modalSelectedYear,
                    // "period":this.modalSelectedPeriod,
                    "comment": this.modalTextArea.trim(),
                    // "userEmail": this.currentUserEmail,
                    "timeStamp": Date().toLocaleString("en-us"),
                    "uuid": this.uuid
                    }
                console.log(blob)
                if(this.modalTextArea != this.editCommentCopy.comment)
                this.postEditComment(blob)
                this.waitingForData = true
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: validation['message'],
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            }
            this.onCalcelClick() 
        },
        deleteComment() {
            this.resetOverlay();
            this.updateOverlayParams({
                display: 'block',
                title: 'Delete Comment',
                message: 'Are you sure you want to delete this comment?',
                // specialClassNames: 'download-in-progress',
                isNotification: false,
                buttons: {
                    type: 'challenge',
                    successHandler: () => {
                        let targetComment = {
                            //mainCategory: this.selectedMainCategory, 
                            programName: this.modalSelectedProgram, 
                            year: this.modalSelectedYear, 
                            //period: this.selectedPeriod, 
                            //programName: this.modalSelectedProgram,
                            uuid: this.uuid
                        }
                        this.initDeleteComment([targetComment]);
                    }
                },
                specialClassNames: 'delete-comment',
                duration: '',
                displayCloseIcon: true,
                background: true
            });
        },
        addComment(){
            this.resetOverlay();
            var validation = this.validateEditComments()
            console.log(`logging addComment() validation: ${JSON.stringify(validation)}`)
            if(validation['status'] == true){
                var blob = {
                    "program": this.modalSelectedProgram,
                    "year": this.modalSelectedYear.getUTCFullYear().toString(),
                    "period":this.modalSelectedPeriod,
                    "comment": this.modalTextArea.trim(),
                    "userEmail": this.currentUserEmail,
                    "timeStamp": Date().toLocaleString("en-us")
                    }
                console.log(blob)
                this.updateComments(blob)
                this.waitingForData = true
            } else {
                this.updateOverlayParams({
                    display: 'block',
                    message: validation['message'],
                    // specialClassNames: 'download-in-progress',
                    isNotification: false,
                    buttons: {
                        type: 'alert',
                        successHandler: () => {}
                    },
                    specialClassNames: 'delete-comment',
                    duration: '',
                    displayCloseIcon: true,
                    background: true
                });
            } 
        },
        onCalcelClick() {
            this.$router.push({name: 'commentary'});
        },
        goBackClick() {
            this.$router.push({name: 'commentary'});         
        },
         setYear(){ 
            this.modalSelectedYear=new Date().getUTCFullYear().toString();
         },
        displayRequiredYears(){
            let years=JSON.stringify(Object.keys(this.years))
            this.disabledDates.customPredictor= function(date) {
            if(years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
        }
    },
        handlePeriodRadioSelection(e) {
            const val = e.target.value;
            if (val === 'All') {
                this.modalSelectedPeriod = 'All';
                this.periodSelector = 'All'
            } else if (val === 'Annual') {
                this.modalSelectedPeriod = 'Annual';
                this.periodSelector = 'Annual'
            } else {
                this.modalSelectedPeriod = "";
                this.periodSelector = val;
                
            }
        },
        hanldeTextAreaFocus(e) {
            this.editInProgress = true;
        },
        hanldeTextAreaBlur(e) {
            if (this.addNewFlow) {
                this.editInProgress = false;
            }
        },
        validateEditComments(){
            console.log(`Validation editComments year: ${this.modalSelectedProgram}, program: ${this.modalSelectedProgram}, period: ${this.modalSelectedPeriod}, text: ${this.modalTextArea}`)
            if(this.modalSelectedYear.length != 0) {
                if(this.modalSelectedProgram.length != 0){
                    if(this.modalSelectedPeriod.length != 0){
                        if(this.modalTextArea.length != 0){
                            if(String(this.modalTextArea).trim().length >= 5){
                                return { 'status': true}
                            } else return { 'status': false, 'message': 'Please enter atleast 5 characters in the notes/comments section'}
                        } else return { 'status': false, 'message': "Please enter your notes, comments before you proceed"}
                    } else return { 'status': false, 'message': 'Please select a valid period before you proceed' }
                } else return { 'status': false, 'message': 'Please select a valid program before you proceed'}
            } else return { 'status': false, 'message': 'Please select a valid year before you proceed'}
        },
    },
    computed: mapGetters(['currentCommentsMainCategory','currentCommentsSubCategory','currentCommentsYear','currentCommentsPeriod','currentCommentsData','isLoggedIn','currentUserName','currentUserEmail','currentUserGroups','currentAccessLevel','currentCommentaryMenu']),
    data: function(){
        return {
            editInProgress: true,
            commentsData : false,
            years: false,
            periods: ['January','February','March','April','May','June','July','August','September','October','November','December','Q1','Q2','Q3','Q4','Annual','All'],
            mPeriods: ['January','February','March','April','May','June','July','August','September','October','November','December'],
            qPeriods: ['Q1','Q2','Q3','Q4'],
            mainCategories: [],
            subCategories: [],
            selectedYear: "",
            selectedMainCategory: "",
            selectedSubCategory: "",
            selectedPeriod:"",
            modalPrograms:[],
            modalSelectedProgram:"",
            modalSelectedYear:"",
            modalSelectedPeriod:"",
            modalTextArea: "",
            modalShow: false,
            waitingForData: false,
            displayMainCategory: "",
            displaySubCategory: "",
            displayPeriod: "",
            displayYear: "",
            initialSetupCompleted: false,
            editCommentCopy: {},
            addNewFlow: false,
            uuid: '',
            periodSelector: '',
            modalSelectedMainCaterogy: '',
            modalSelectedSubCaterogy: '',
            disabledDates:{ customPredictor: function(date) {
                if(typeof this.years!=='undefined'){
            if(this.years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
            }}},
        }
    },
    watch: {
         currentCommentaryMenu: function(){
            this.years = this.currentCommentaryMenu;
         },
        selectedYear: function(){  
            this.mainCategories = [];
            this.subCategories = [];
            if (this.selectedYear.length > 0){
                this.mainCategories = this.years[this.selectedYear]
            }
            
        },
        modalSelectedYear: function(){
            this.modalPrograms = [];
              let selectedYear=(!this.addNewFlow)?this.modalSelectedYear.toString():new Date(this.modalSelectedYear).getUTCFullYear().toString();  
            if (selectedYear.length > 0){
                this.modalPrograms = this.years[selectedYear][this.modalSelectedMainCaterogy === 'Verticals' ? 'Verticals' : 'Providers']
                console.log("Adding modal programs")
                console.log(this.modalSelectedProgram)
            }
        },
        selectedMainCategory: function(){
            this.subCategories = [];
            if (this.selectedMainCategory.length > 0){
                this.subCategories = this.years[new Date(this.selectedYear).getUTCFullYear()][this.selectedMainCategory]
            }
        },
    },
    created(){
        this.getMenuOptions(true);
        let target = this.$route.params.comment && JSON.parse(this.$route.params.comment);
        console.log('------', target);

        // to handle add comment use case.
        if (!target || target.addNew) {
            target = {
                program_name: '',
                metaData: {
                    selectedYear: '',
                    selectedPeriod: '',
                    mainCategory: '',
                    subCategory: '',
                },
                comment: '',
                edit: '',
                addNew: target && target.addNew ? target.addNew : false,
            }
        }
        this.editCommentCopy = target;
        this.addNewFlow = target.addNew;
        this.years = this.currentCommentaryMenu; 
        this.modalSelectedProgram = this.editCommentCopy.program_name // this.editCommentCopy.program_name; //.toUpperCase();
        this.modalSelectedYear = this.editCommentCopy.metaData.selectedYear;
        this.modalSelectedPeriod = this.editCommentCopy.metaData.selectedPeriod;
        this.modalSelectedMainCaterogy = "Providers", // this.editCommentCopy.metaData.mainCategory, //Providers
        this.modalSelectedSubCaterogy = this.editCommentCopy.program_name,
        this.modalTextArea = this.editCommentCopy.comment;
        this.uuid = this.editCommentCopy.uuid;
        if (!this.addNewFlow) {
            this.editInProgress=true;   
            if (this.modalSelectedPeriod && this.modalSelectedPeriod.toLowerCase() === 'all') {
                this.periodSelector = 'All';
            } else if (this.modalSelectedPeriod && this.modalSelectedPeriod.toLowerCase() === 'annual') {
                this.periodSelector = 'Annual';
            } else if (this.modalSelectedPeriod && this.modalSelectedPeriod.toLowerCase().split("")[0] === 'q') {
                this.periodSelector = 'Quarter';
                this.qPeriods=[this.modalSelectedPeriod];
            } else {
                this.periodSelector = 'Month';
                this.mPeriods=[this.modalSelectedPeriod];
            }
        } else {
            this.periodSelector = 'Month';
            this.modalSelectedPeriod = "";
        }
    }
}
</script>

<style scoped>
.no-display {
    display: none;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;
    border-radius: 5px;
    width: 120px;

}
.btn-light-arp {
    color: #000 !important;
    background-color: #fff !important;
    font-weight: bold !important;
    border-radius: 5px;
}
.period-radio-group {
    display: flex;
    justify-content: space-between;
}

.filter-label {
    font-weight: bold;
    margin-bottom: 8px;
    margin-top: 20px;
}
.form-title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 12px;
    border-bottom: 2px solid #eeeeee;
    margin-bottom: 12px;
}
.main-padding {
    padding: 20px;
}
.back-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: bold;
}
.ediAddCommentSection {
    background-color: white;
    display: block;
    margin: auto;
    width: 70%;
    background-clip: content-box;
}
.addEditButtonGroup {
    display: flex;
    justify-content: flex-end;
    border-top: 2px solid #eeeeee;
    margin-top:-15px;
    padding-top:15px
}
.addEditCommentContainer {
    background-color: #EEEEEE;
    height: calc(100vh - 175px);
    display: flex;
    align-items: center;
    justify-content: center;
}
.comments-title-section {
    top: 60px;
    left: 0px;
    width: 100%;
    height: 90px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.comments-title {
    margin-left: 28px;

    font-weight: 300;
}
.dropdown {
    margin: 10px 0;
    padding: 10px 0;
    border-bottom: 1px solid #DDD;
}
.someclass {
   overflow-y: scroll;
   max-height: 70vh;
}

.dropdown span {
    display:inline-block;
    width: 80px;
}
.main-btn {
    background-color: #FBC743;
    color: black;
}
.radio {
  position: relative;
  cursor: pointer;
  line-height: 16px;
  font-size: 14px;
  display: flex;
}
.radio .label {
  position: relative;
  display: block;
  float: left;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  border: 1px solid gray;
  border-radius: 100%;

}
.radio .label:after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: #000000;
  opacity: 0;
  pointer-events: none;
}
input[type="radio"]:checked + .label {
  border-color: #000000;
}
input[type="radio"]:checked + .label:after {
  transform: scale(1);
  opacity: 1;
}
.cntr {
  position: absolute;
  top: calc(50% - 5px);
  left: 0;
  width: 100%;
  text-align: center;
}
.hidden {
  display: none;
}
.credit {
  position: fixed;
  right: 16px;
  bottom: 16px;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.6;
}

.lable-lite {
    color: #A4ADB3;
}

.commentLatestEdit {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: -4px 8px 26px 0px;
    font-weight: 400;
    font-family: Arial;
    font-size: 16px;
}

.commentLatestEdit .time-white {
    width: 30px;
    margin-bottom: 2px;
    margin-right: 4px;
    margin-left: -4px;
}

.commentLatestEdit .editorName {
    font-weight: 400;
}

.commentLatestEdit .editorEmail {
    font-size: 14px;
    margin-left: 4px;
}
</style>